// extracted by mini-css-extract-plugin
export default {"container":"SearchBanner-module__container___1cTc-","searchIcon":"SearchBanner-module__searchIcon___Pjv9Z"};